import {initMainHeader} from '../js/src/header-init';
import {
    addToCartBtn,
    addToCartUtil,
    cartStoreSubscribe,
    getComponentsData,
    setComponentsList,
    manageBuyBtn
} from "../js/src/cart-utils";
import {replaceLAZoneAbbrNow} from "../js/src/utils";
import '../scss/pages/shop-now.scss';

initMainHeader();
replaceLAZoneAbbrNow();

const PAGE_SIZE = 20;
let currentPage = 1;
const loader = document.getElementById('filter-loader');
let componentsInCart = {};


cartStoreSubscribe(data => {
    componentsInCart = data;

    Object.keys(data).forEach(serverId => {
        manageBuyBtn(serverId, false);
    })
});

/**
 *
 */
global.onFilterChange = (isGetMoreMode) => {
    showLoading(true);

    try {
        currentPage = isGetMoreMode ? currentPage + 1 : 1;
        loadData(isGetMoreMode);

    } catch (e) {
        showLoading(false);
        showNextResultBtn(false);
        console.warn('Error');
    }
}


/**
 *
 * @param serverId
 * @param type
 * @param btn
 */
global.addToCart = (serverId, type, btn) => {
    const component = getComponentsData().find(c => c.serverId == serverId);

    if (!component) {
        return
    }

    const eParams = {
        item_id: component.serverId,
        item_name: component.title,
        item_brand: component.brand,
        item_category: component.category,
        item_category2: component.category2,
        price: component.price
    }

    addToCartUtil(serverId, type, btn, eParams)
};

/**
 *
 * @param isGetMoreMode
 */
function loadData(isGetMoreMode) {
    const parentBox = document.getElementById('product-list-box');
    const data = getFilter();

    fetch('/getShopNowList?' + new URLSearchParams(data))
        .then(r => r.json())
        .then(success)
        .catch(error);

    /**
     *
     * @param response
     */
    function success(response) {
        showLoading(false);
        showNextResultBtn(response && response.length === PAGE_SIZE);

        if (!isGetMoreMode) {
            parentBox.innerHTML = '';
        }

        if (!response || !response.length) {
            if (!isGetMoreMode) {
                parentBox.innerHTML = '<p class="no-config"> No server configurations were found.</p>';
            }
        } else {
            response.forEach(item => {
                parentBox.insertAdjacentHTML('beforeend', getRowHtml(item));
                item.brand = item.itemBrand;
                item.category = item.itemCategory;
                item.category2 = item.itemCategory2;
            });

            setComponentsList(response);
            setTimeout(() => {
                Object.keys(componentsInCart).forEach(sid => manageBuyBtn(sid, false))
            }, 200);

        }
    }

    /**
     *
     */
    function error() {
        showLoading(false);

        if (!isGetMoreMode) {
            parentBox.innerHTML = '<p class="err">An error occurred, please try again later</p>';
        } else {
            showNextResultBtn(false);
        }
    }
}

/**
 *
 * @returns {{priceMin: string, cpuFilter: string, priceMax: string, perPage: number, ramFilter: string, serverCategoryId: string, page: number}}
 */
function getFilter() {
    return {
        priceMin:  encodeURIComponent(document.getElementById('p-min').value || 0),
        priceMax: encodeURIComponent(document.getElementById('p-max').value || 0),
        cpuFilter: encodeURIComponent(document.getElementById('sel-cpu').value || ''),
        ramFilter: encodeURIComponent(document.getElementById('sel-ram').value || ''),
        serverCategoryId: encodeURIComponent((document.getElementById('server_category').innerHTML || '').replaceAll(/\D/g, '') || 0),
        page: currentPage,
        perPage: PAGE_SIZE
    }
}

/**
 *
 * @param state
 */
function showLoading(state) {
    const f = state ? 'add' : 'remove';

    loader.classList[f]('show');
}

/**
 *
 * @param state
 */
function showNextResultBtn(state) {
    document.getElementById('next-result').classList.toggle('hidden', !state);
}

/**
 *
 * @param conf
 * @returns {string}
 */
function getRowHtml(conf) {
    const defImg = window.__itc_def_img;

    return `
        <div class="item-row">
            <div class="server-image">
                <a href="${ conf.link }" title="${ conf.title } Image" target="_blank">
                    <img
                        class="prod img-thumbnail"
                        src="${ conf.imageFull ? conf.imageFull : defImg }"
                        alt="${ conf.title }"
                        width="400"
                        height="300"
                        onerror="this.classList.add('b-error')"
                     >
                </a>
            </div>
            <div class="data-box">
                <div>
                    <a href="${ conf.link }" class="conf-title link_server" title="Show ${ conf.title } Details" target="_blank">
                        ${ conf.title }
                    </a>
                    <b class="conf-num">Conf # P${ conf.serverId }</b>
                </div>
                <div class="data-row">
                    <div class="description-box">
                        ${conf.confLink ?
                        `<p><a href="${ conf.confLink }">Configurations available </a></p>` : '' }
                        <p class="with-icon line">
                            <b>Availability:</b> ${conf.availability == 'In Stock' ? '<span class="in-stock">In Stock</span>' : `<span class="text-error">${conf.availability }</span>`}
                            ${availableSvg()}
                        </p>
                        <p>Condition: ${ conf.condition }</p>
                        <p>Warranty: ${ conf.warranty }</p>
                    </div>
                    <div class="price-box">
                        <p content="${ conf.price }" class="price-value">${ conf.priceFormatted }</p>
                        <div class="btn-box">
                            <a class="btn buy-btn btn-lg btn-primary" href="${ conf.link }" target="_blank">
                                Details
                            </a>
                            ${ addToCartBtn(conf.serverId, conf.productType) }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `
}

function availableSvg() {
    return '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 10.6667V5.33335C13.9998 5.09953 13.938 4.86989 13.821 4.66746C13.704 4.46503 13.5358 4.29692 13.3333 4.18002L8.66667 1.51335C8.46397 1.39633 8.23405 1.33472 8 1.33472C7.76595 1.33472 7.53603 1.39633 7.33333 1.51335L2.66667 4.18002C2.46418 4.29692 2.29599 4.46503 2.17897 4.66746C2.06196 4.86989 2.00024 5.09953 2 5.33335V10.6667C2.00024 10.9005 2.06196 11.1301 2.17897 11.3326C2.29599 11.535 2.46418 11.7031 2.66667 11.82L7.33333 14.4867C7.53603 14.6037 7.76595 14.6653 8 14.6653C8.23405 14.6653 8.46397 14.6037 8.66667 14.4867L13.3333 11.82C13.5358 11.7031 13.704 11.535 13.821 11.3326C13.938 11.1301 13.9998 10.9005 14 10.6667Z" stroke="#5B6B70" stroke-linecap="round" stroke-linejoin="round"/><path d="M2.17993 4.64001L7.99993 8.00668L13.8199 4.64001" stroke="#5B6B70" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 14.72V8" stroke="#5B6B70" stroke-linecap="round" stroke-linejoin="round"/></svg>'
}

function initCustomSelects() {
    document.querySelectorAll('.custom-select').forEach(wrap => {
        const trigger = wrap.querySelector('.custom-select__trigger');
        const panel = wrap.querySelector('.custom-select__panel');
        const search = wrap.querySelector('.custom-select__search');
        const list = wrap.querySelector('.custom-select__list');
        const hidden = wrap.querySelector('input[type="hidden"]');
        const items = Array.from(list.querySelectorAll('li'));

        trigger.addEventListener('click', () => {
            const isOpen = !panel.hidden;
            document.querySelectorAll('.custom-select__panel').forEach(p => { p.hidden = true; });
            if (!isOpen) {
                panel.hidden = false;
                search.value = '';
                items.forEach(li => li.style.display = '');
                search.focus();
            }
        });

        search.addEventListener('input', () => {
            const q = search.value.toLowerCase();
            items.forEach(li => {
                li.style.display = li.textContent.toLowerCase().includes(q) ? '' : 'none';
            });
        });

        list.addEventListener('click', e => {
            const li = e.target.closest('li');
            if (!li) return;
            hidden.value = li.dataset.value;
            trigger.textContent = li.textContent;
            panel.hidden = true;
        });
    });

    document.addEventListener('click', e => {
        if (!e.target.closest('.custom-select')) {
            document.querySelectorAll('.custom-select__panel').forEach(p => { p.hidden = true; });
        }
    });

    document.querySelectorAll('#p-min, #p-max').forEach(input => {
        input.addEventListener('keydown', e => {
            if (e.key === 'Enter') onFilterChange(0);
        });
    });
}

initCustomSelects();


